import { useState, FC } from 'react';

import { VSpacing } from '@hh.ru/magritte-ui';

import AccountTypeSwitch from 'src/components/AccountLogin/components/AccountTypeSwitch/AccountTypeSwitch';
import Agreement from 'src/components/AccountLogin/components/Agreement/Agreement';
import { useApplicantRenewedAuthExp } from 'src/hooks/useApplicantRenewedAuthExp';
import { useSelector } from 'src/hooks/useSelector';
import { UserType } from 'src/models/userType';

import ApplicantLoginCard from 'src/components/AccountLogin/CombinedLoginCards/ApplicantLoginCard';
import EmployerLoginCard from 'src/components/AccountLogin/CombinedLoginCards/EmployerLoginCard';
import ExpApplicantLoginCard from 'src/components/AccountLogin/CombinedLoginCards/ExpApplicantLoginCard';
import ApplicantLoginProvider from 'src/components/AccountLogin/CombinedLoginCards/ExpApplicantLoginCard/context';

const AccountLogin: FC = () => {
    const anonymousUserType = useSelector((state) => state.anonymousUserType);
    const loginTileType = useSelector((state) => state.loginTileType);
    const backUrl = useSelector((state) => state.authUrl?.backurl);
    const [showAgreement, setShowAgreement] = useState(true);
    const [shouldShowAccountTypeSwitch, setShowAccountTypeSwitch] = useState(!loginTileType);
    const { isApplicantRenewedAuthExp, isApplicantRenewedAuthExpC } = useApplicantRenewedAuthExp();

    const shouldSkipAccountTypeSelection = isApplicantRenewedAuthExpC || !!backUrl?.includes('oauth');

    const applicantLogin = isApplicantRenewedAuthExp ? (
        <ApplicantLoginProvider
            initialStep={shouldSkipAccountTypeSelection ? 'enter-credentials' : 'account-type-selection'}
            initialFlow={shouldSkipAccountTypeSelection ? 'sign-in' : null}
        >
            <ExpApplicantLoginCard />
        </ApplicantLoginProvider>
    ) : (
        <ApplicantLoginCard
            key="applicant_authorization"
            onSignUp={() => {
                setShowAgreement(false);
                setShowAccountTypeSwitch(false);
            }}
        />
    );
    const employerLogin = (
        <EmployerLoginCard key="employer_authorization" onNextStep={() => setShowAccountTypeSwitch(false)} />
    );
    const loginCard = anonymousUserType === UserType.Applicant ? applicantLogin : employerLogin;

    if (isApplicantRenewedAuthExp) {
        return loginCard;
    }

    return (
        <>
            {loginCard}
            <VSpacing default={24} />
            {shouldShowAccountTypeSwitch && <AccountTypeSwitch />}
            {showAgreement && (
                <>
                    <VSpacing default={24} />
                    <Agreement isApplicant={anonymousUserType === UserType.Applicant} />
                </>
            )}
        </>
    );
};

export default AccountLogin;
